__turbopack_context__.v({
  "className": "crimson_text_31ea5956-module___A-nla__className",
});
